import { Modal, Card, contexts } from 'lib_ui-primitives';
import { useEffect, useState, useContext, createElement as rc, Fragment } from 'react';
import { ThemeContext } from 'styled-components';
import useEventSink from '../../hooks/useEventSink';
import { metadata } from 'lib_ui-services';
import { CardHeader, HeaderText } from './styles';

export default function SimpleDialog(props) {
    const {
        id,
        openAction,
        closeAction,
        namespace,
        relation,
        title,
        openActionType: openActionTypeOverride,
        closeActionType: closeActionTypeOverride
    } = props.hNode ?? {};
    const [subscribe] = useEventSink();
    const { smallMobile } = useContext(ThemeContext);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        let openActionType;
        if (['edit', 'new'].includes(openAction)) {
            openActionType = openActionTypeOverride || { verb: openAction, namespace, relation, status: 'success' };
        } else {
            openActionType = openActionTypeOverride || { verb: openAction, namespace, relation };
        }
        const closeActionType = closeActionTypeOverride || { verb: closeAction, namespace, relation };
        const unsubscribes = [
            subscribe(openActionType, () => {
                setVisible(true);
            }),
            subscribe(closeActionType, () => setVisible(false))
        ];
        // unsubscribe during cleanup
        return () => unsubscribes.forEach(u => u());
    }, [openAction, closeAction, namespace, subscribe, relation, openActionTypeOverride, closeActionTypeOverride]);
    const scrollingRequired =
        metadata.containsHNodeType(props.hNode, 'Form') || metadata.containsHNodeType(props.hNode, 'SingleRecordForm');
    const hasDialogTitle = !smallMobile && !!title;
    // prettier-ignore
    return rc(Modal, { id: `modalSimpleDialog-${id}`, visible, scrollingRequired },
        rc(Card, null,
            hasDialogTitle && rc(CardHeader, null, rc(HeaderText, null, title)),
            rc(contexts.DialogTitleContext.Provider, { value: hasDialogTitle },
                rc(Fragment, null, props.children)
            )
        )
    );
}
